import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // ✅ required for toggler and dropdown
import './App.css'; // ✅ Global styles
import Header from './Components/Header/Header';
import Sliders from './Components/Home/Sliders';
import Home from './Components/Home/Home';
import { Footer } from './Components/Footer/Footer';
import About from './Components/About/About';
import { Courses } from './Components/Courses/Courses';
import { Contact } from './Components/Contact/Contact';
import { Coursedetails } from './Components/Pages/Coursedetails';
import { Futures } from './Components/Pages/Futures';
import { Instruction } from './Components/Pages/Instruction';
import Gallery from "./Components/Gallery/Gallery";
import  SapFincon  from './Components/Courses/SapFincon';
import  SapProcurementInventory  from './Components/Courses/SapProcurementInventory';
import SapHCMWorkforce  from './Components/Courses/SapHCMWorkforce';
import SapPM from './Components/Courses/SapPM';
import SapPS from './Components/Courses/SapPS';
import SapPP from './Components/Courses/SapPP';
import SapSD from './Components/Courses/SapSD';
import SapAbap from './Components/Courses/SapAbap';
import TestimonialSection from './Components/Pages/TestimonialSection';
import BlogList from './Components/Blog/BlogList';
import ScrollToTop from './Components/ScrollToTop';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Login from './Components/Loginpage/Login';
import PostJob from './Components/Postjobs/PostJob';

import Careers from './Components/Careers/Careers';
import GalleryEdit from './Components/GalleryEdit/GalleryEdit';
import StudentApplicationForm from './Components/StudentApplicationForm/StudentApplicationForm';
import StudentApplicationFormview from './Components/StudentApplicationForm/StudentApplicationFormview';
import SliderAdmin from './Components/SliderAdmin/SliderAdmin';
import Slider from 'react-slick';
import { Admin } from './Components/AdminDashbord/Admin'; // ✅ CORRECT
import {Slidar} from './Components/AdminDashbord/Slidar';
import AdminBlogForm from './Components/Blog/AdminBlogForm';
import BlogDetail from './Components/Blog/BlogDetail';
import  AdminTestimonial  from './Components/AdminTestimonialpanel/AdminTestimonial';
import  Tstimonialshow  from './Components/AdminTestimonialpanel/Tstimonialshow';
import DownloadForm from './Components/DownloadForm/DownloadForm';
import DownloadSubmissions from './Components/DownloadForm/DownloadSubmissions';
import WhatsAppPopup from './Components/WhatsAppPopup';
import BackToTop from './Components/ScrollTop/Scroll';
import FontSetup from './Components/Pages/Font family/Fontsetup';
import Bloghome from './Components/Blog/Bloghome';
import AdminAchievements from './Components/AdminTestimonialpanel/AdminAchievements';
import AdminTestimonials from './Components/AdminTestimonialpanel/AdminTestimonials';
import Aboutdat from './Components/AdminTestimonialpanel/Aboutdat';
import ContactAdmin from './Components/Contact/ContactAdmin';
import ProductApplicationForm from './Components/Blog/ProductApplicationForm';
import AdminProductApplications from './Components/Blog/AdminProductApplications';
import SellApplicationForm from './Components/Blog/SellApplicationForm';
import AdminsellApplications from './Components/Blog/AdminsellApplications';

import SellList from './Components/Blog/SellList';
import AdminsellForm from './Components/Blog/AdminsellForm';
import SellDetail from './Components/Blog/SellDetail';
import AdminSellsForm from './Components/Blog/AdminsellForm';
import Selhome from './Components/Blog/Selhome';





const App = () => {
  return (
    <Router>
      <div className='container-fluid'>
        <div className="app-scroll-container">  {/* ✅ Added global scroll wrapper */}
        <FontSetup /> {/* ✅ This sets up the font family */}
      <ScrollToTop /> {/* ✅ This ensures every route starts from the top */}
      <Header />

      <Routes> 
      
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/course" element={<Courses />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/coursed" element={<Coursedetails />} />
        <Route path="/futur" element={<Futures />} />
        <Route path="/intru" element={<Instruction />} />
        <Route path="/test" element={<TestimonialSection />} />
        <Route path="/gallerry" element={<Gallery />} />
        <Route path="/sapfin" element={<SapFincon />} />
        <Route path="/sapmm" element={<SapProcurementInventory />} />
        <Route path="/saphcm" element={<SapHCMWorkforce />} />
        <Route path="/sappm" element={<SapPM />} />
        <Route path="/sapps" element={<SapPS />} />
        <Route path="/sappp" element={<SapPP />} />
        <Route path="/sapsd" element={<SapSD />} />
        <Route path="/sapab" element={<SapAbap />} />
        <Route path="/blog" element={<BlogList />} />
         <Route path="/login" element={<Login />} />
         <Route path="/jobpost" element={<PostJob />} />
           <Route path="/admin" element={<Admin />} />
            <Route path="/careers" element={<Careers />} />
             <Route path="/GalleryEdit" element={<GalleryEdit />} />
             <Route path="/jobap" element={<StudentApplicationForm />} />
          <Route path="/adminview" element={<StudentApplicationFormview />} />
<Route path="/adminview/edit/:id" element={<StudentApplicationFormview />} />

            <Route path="/Slider" element={<Sliders />} />
            <Route path="/Adminslider" element={<SliderAdmin />} />
             <Route path="/Slidar" element={<Slidar />} />
             <Route path="/Adminblog" element={<AdminBlogForm />} />
             <Route path="/BlogDetail" element={<BlogDetail />} />
             <Route path="/AdminTest" element={<AdminTestimonial />} />
             <Route path="/Testishow" element={<Tstimonialshow />} />
              <Route path="/Download" element={<DownloadForm />} />
               <Route path="/DownloadSubmission" element={<DownloadSubmissions />} />
               <Route path="/homeblog" element={<Bloghome />} />
                <Route path="/logo" element={<AdminAchievements />} />
                 <Route path="/empdata" element={<AdminTestimonials />} />
                 <Route path="/Aboutdat" element={<Aboutdat />} />
                 <Route path="/Admincontactpage" element={<ContactAdmin />} />
                 <Route path="/ProductApplicationForm" element={<ProductApplicationForm />} />
                  <Route path="/AdminProductApplications" element={<AdminProductApplications />} />
                  <Route path="/SellApplicationForm" element={<SellApplicationForm />} />
                  <Route path="/AdminsellApplications" element={<AdminsellApplications />} />
                  <Route path="/SellDetail" element={<SellDetail />} />
                 
                    <Route path="/AdminSell" element={<AdminsellForm />} /> 
                      <Route path="/Sells" element={<SellList />} />
                      <Route path="/Adminsellform" element={<AdminSellsForm />} />
                       <Route path="/AdminsellApplications" element={<AdminsellApplications />} />
                       <Route path="/Selhome" element={<Selhome />} />

                 

             
      </Routes>
      <BackToTop/>
<WhatsAppPopup />
      <Footer /></div></div>
      
    </Router>
  );
};



export default App;

